import * as React from "react";
import { VariantProps, cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
import styles from "./button.module.css";

export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none disabled:opacity-50 disabled:pointer-events-none cursor-pointer ",
  {
    variants: {
      variant: {
        default: "text-[#9F9DA1] hover:text-white",
        outline: "border border-gray-300 text-gray-800 hover:bg-gray-100 ",
        primary: `bg-foreground text-stone-200 rounded-full ${styles.btn}`,
        filled: "text-white",
        gradient: "text-white rounded-full border",
      },
      size: {
        sm: "px-3 py-1 text-xs",
        md: "px-4 py-[10px] text-base",
        lg: "px-5 py-3 text-lg",
        default: "lg:text-xs text-[12px] sm:py-3 sm:px-6 py-1.5 px-2",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size, variant, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(buttonVariants({ variant, size }), className)}
        {...props}
      >
        <div className="z-0 flex justify-center items-center gap-1">
          {children}
        </div>
      </button>
    );
  }
);

Button.displayName = "Button";
